import React from "react";
import { FiWifi } from "react-icons/fi";
import { IoLogoNoSmoking } from "react-icons/io";
import { TbAirConditioning } from "react-icons/tb";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import cift4 from "../../assets/images/oda2/cift4.jpg";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import HeaderToggle from "../../components/headerToggle/HeaderToggle";
import data from "../../components/services/index";
import useWindowSize from "../../hooks/useWindowSize";
import "./RoomScreen.css";
import RoomCard from "./components/RoomCard.js";

function RoomScreen() {
  const { width: screenWidth } = useWindowSize();

  return (
    <div className="App">
      {/* Header */}
      {screenWidth < 910 ? (
        <HeaderToggle />
      ) : (
        <Header />
      )}

      {/* Hero Image */}
      {screenWidth > 910 ? (
        <img src={cift4} className="room-header-detail-image" alt="Timya Otel Odaları" />
      ) : (
        <div className="room-header-min-screen" />
      )}

      {/* Page Header */}
      <section className="room-header-row">
        <h1 className="room-title">ODALARIMIZ</h1>
        <p className="room-explanation">
          Hoş Geldiniz! Otelimizdeki odalar, konforun, şıklığın ve huzurun
          mükemmel bir karışımını sunuyor. Tatiliniz veya iş seyahatiniz için
          ideal bir kaçış noktası olan odalarımız, konforlu yataklar ve özenle
          seçilmiş detaylarla donatıldı. Her odamızda modern olanaklarla
          donatılmış banyolar, ücretsiz Wi-Fi erişimi bulunmaktadır. Keyifli bir
          konaklama deneyimi için bizi tercih ettiğiniz için teşekkür ederiz.
          Sizleri ağırlamaktan mutluluk duyacağız!
        </p>
      </section>

      {/* Room Cards */}
      <section className="room-list">
        {data.rooms.map((room, index) => {
          if (index % 2 === 0) {
            return (
              <div className="room-row" key={room.title}>
                <RoomCard room={room} />
                <div className="room-spacer" />
                {data.rooms[index + 1] && (
                  <RoomCard room={data.rooms[index + 1]} />
                )}
              </div>
            );
          }
          return null;
        })}
      </section>

      {/* Amenities Section */}
      <section className="amenities-section">
        <div className="icon-container">
          <div className="room-icon-row">
            <FiWifi fontSize={60} color="var(--color-primary, #e01616)" />
            <h3 className="icon-title">Wi-Fi</h3>
          </div>
          <div className="room-icon-row">
            <IoLogoNoSmoking fontSize={60} color="var(--color-primary, #e01616)" />
            <h3 className="icon-title">Sigara İçilmez</h3>
          </div>
          <div className="room-icon-row">
            <TbAirConditioning fontSize={60} color="var(--color-primary, #e01616)" />
            <h3 className="icon-title">Klima</h3>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default RoomScreen;
